import Vue from 'vue';
import VueRouter from 'vue-router';
import VuePageTransition from 'vue-page-transition'
Vue.use(VueRouter);
Vue.use(VuePageTransition)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { transition: 'fade-in-up', title: 'Biscuit & Chai | Web, App & Backend Development' },
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/projects',
    name: 'Projects',
    meta: { transition: 'fade-in-up', title: 'Projects | Biscuit & Chai' },
    component: () => import('../views/Projects.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: { transition: 'fade-in-up', title: 'Contact Us | Biscuit & Chai' },
    component: () => import('../views/Contact.vue'),
  },
  {
    path: '/follow-us',
    name: 'FollowUs',
    meta: { transition: 'fade-in-up', title: 'Follow Us | Biscuit & Chai' },
    component: () => import('../views/FollowUs.vue'),
  },
  {
    path: '/community',
    name: 'Community',
    meta: { transition: 'fade-in-up', title: 'Community | Biscuit & Chai' },
    component: () => import('../views/Community.vue'),
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    meta: { transition: 'fade-in-up', title: 'Thank You | Biscuit & Chai' },
    component: () => import('../views/ThankYou.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    meta: { transition: 'fade-in-up', title: 'Privacy Policy | Biscuit & Chai' },
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/open-source/py_rankaggregation',
    redirect: () => {
      window.location.pathname = '/py_rankaggregation/index.html'
    }
  },
  // {
  //   path: '/marketing/web',
  //   name: 'Brewing Websites',
  //   meta: { transition: 'fade-in-up' },
  //   component: () => import('../views/WebMarketing.vue'),
  // },
  {
    path: '*',
    name: 'NotFound',
    meta: { transition: 'fade-in-up', title: 'Page Not Found | Biscuit & Chai' },
    component: () => import('../views/NotFound.vue'),
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

router.afterEach((to) => {
  document.title = (to.meta && to.meta.title) || 'Biscuit & Chai';
});

export default router;
